import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

function isIosInAppBrowser() {
  const ua = (navigator.userAgent || navigator.vendor || "").toLowerCase();
  const platform = (navigator.platform || "").toLowerCase();

  // Skip fallback for installed PWAs
  const isStandalonePWA =
    (window.matchMedia &&
      window.matchMedia("(display-mode: standalone)").matches) ||
    (typeof navigator.standalone === "boolean" && navigator.standalone);
  if (isStandalonePWA) return false;

  // Detect iOS
  const iOS =
    /ipad|iphone|ipod/.test(ua) ||
    (platform === "macintel" && navigator.maxTouchPoints > 1);

  if (!iOS) return false;

  // Known in-app containers - if ANY of these are present, it's definitely in-app
  const isKnownInApp =
    /(instagram|fbav|fban|snapchat|pinterest|linkedin|twitter|tiktok|wechat|line|weibo|gmail|reddit|messenger)/.test(
      ua
    );

  if (isKnownInApp) return true;

  // Proper Safari detection: Safari has "safari" in UA but NOT "chrome" or "crios"
  // Real Safari will have both "safari" and "version" in the UA
  const isSafari =
    /safari/.test(ua) && /version/.test(ua) && !/chrome|crios/.test(ua);

  // Other standalone iOS browsers
  const isOtherStandaloneBrowser =
    /(crios|fxios|edgios|opios|duckduckgo|brave)/.test(ua);

  // If it's Safari or another standalone browser, it's NOT in-app
  if (isSafari || isOtherStandaloneBrowser) return false;

  // If we're on iOS but didn't match any known browser, assume it's in-app
  return true;
}

const root = ReactDOM.createRoot(document.getElementById("root"));

(async () => {
  const inApp = isIosInAppBrowser();
  const onInAppPath = /\/inapp\/?$/.test(location.pathname);

  // If we're on /inapp but NOT in an in-app browser, redirect to the original URL or home
  if (onInAppPath && !inApp) {
    const originalUrl = sessionStorage.getItem("original_url");
    if (originalUrl) {
      // Redirect to the original URL
      window.location.replace(originalUrl);
    } else {
      // No original URL saved, go to home
      window.location.replace("/");
    }
    return;
  }

  // If we ARE in an in-app browser, show the fallback
  if (inApp) {
    const { default: InAppFallbackScreen } = await import(
      "./Screen/InAppFallbackScreen.jsx"
    );
    const { BrowserRouter, Routes, Route } = await import("react-router-dom");
    root.render(
      <React.StrictMode>
        <BrowserRouter>
          <Routes>
            <Route path="/inapp" element={<InAppFallbackScreen />} />
            <Route path="*" element={<InAppFallbackScreen />} />
          </Routes>
        </BrowserRouter>
      </React.StrictMode>
    );
    return;
  }

  // Only real browsers reach here: load main app + SW
  const { default: Root } = await import("./App.jsx");
  root.render(<Root />);

  if ("serviceWorker" in navigator) {
    try {
      const registration = await navigator.serviceWorker.register(
        "/firebase-messaging-sw.js"
      );
      console.log("SW registered:", registration.scope);

      const {
        requestNotificationPermission,
        setupForegroundNotificationListener,
        setupTokenUserAssociation,
      } = await import("./utils/pushNotificationService");

      const token = await requestNotificationPermission();
      if (token) {
        console.log("FCM token:", token);
        setupForegroundNotificationListener((payload) => {
          console.log("Foreground notification:", payload);
        });
      }
      setupTokenUserAssociation();
    } catch (e) {
      console.error("Service Worker registration failed:", e);
    }
  }
})();

// OLD CODE

// import ReactDOM from "react-dom/client";
// import Root from "./App.jsx";
// import "./index.css";
// import {
//   requestNotificationPermission,
//   setupForegroundNotificationListener,
//   setupTokenUserAssociation,
// } from "./utils/pushNotificationService";

// // Register service worker and request notification permission
// if ("serviceWorker" in navigator) {
//   navigator.serviceWorker
//     .register("/firebase-messaging-sw.js")
//     .then((registration) => {
//       console.log("Service Worker registered with scope:", registration.scope);

//       // Request notification permission immediately on page load
//       requestNotificationPermission().then((token) => {
//         if (token) {
//           console.log("Notification permission granted, FCM token:", token);

//           // Set up foreground notification listener
//           setupForegroundNotificationListener((payload) => {
//             console.log("Notification received in foreground:", payload);
//           });
//         }
//       });

//       // Set up token-user association for when users log in
//       setupTokenUserAssociation();
//     })
//     .catch((error) => {
//       console.error("Service Worker registration failed:", error);
//     });
// }

// ReactDOM.createRoot(document.getElementById("root")).render(<Root />);
